<section class="email-viewer" [attr.aria-busy]="loading">
    <div *ngIf="loading" class="email-viewer__loading" aria-label="Loading email">
        <span class="email-viewer__skeleton email-viewer__skeleton--sender"></span>
        <span class="email-viewer__skeleton email-viewer__skeleton--subject"></span>
        <span class="email-viewer__skeleton email-viewer__skeleton--body"></span>
    </div>

    <div *ngIf="!loading && loadFailed" class="email-viewer__status" role="alert">
        <span class="far fa-exclamation-circle" aria-hidden="true"></span>
        <span>Could not load email</span>
    </div>

    <ng-container *ngIf="!loading && email">
        <header class="email-viewer__header">
            <div class="email-viewer__sender-row">
                <span class="email-viewer__avatar" aria-hidden="true">
                    <img *ngIf="senderPhotoUrl" [src]="senderPhotoUrl" alt="" (error)="onSenderPhotoError()" />
                    <span *ngIf="!senderPhotoUrl">{{ senderInitials || "@" }}</span>
                </span>
                <div class="email-viewer__sender">
                    <strong>{{ email.sender_name || email.sender_email }}</strong>
                    <span *ngIf="email.sender_name && email.sender_email">{{ email.sender_email }}</span>
                </div>
                <time *ngIf="email.datetime_sent" class="email-viewer__date">{{ email.datetime_sent | formatDate: "datetime" : false : true }}</time>
                <div class="email-viewer__toolbar">
                    <tt-button
                        ttType="icon"
                        [ttIcon]="bodyDarkMode ? 'fas fa-sun' : 'fas fa-moon'"
                        [ttTooltipText]="bodyDarkMode ? 'emailview_light_mode' : 'emailview_dark_mode'"
                        (ttClick)="toggleBodyTheme()"
                    ></tt-button>
                    <tt-button
                        *ngFor="let action of actions"
                        ttType="icon"
                        [ttIcon]="action.icon"
                        [ttTooltipText]="action.title"
                        (ttClick)="action.onClick($event)"
                    ></tt-button>
                    <ng-container *ngIf="replyView === 'inline'">
                        <tt-button ttType="icon" ttIcon="far fa-reply" ttTooltipText="emailview_send_email" (ttClick)="reply.emit($event)"></tt-button>
                        <tt-button ttType="icon" ttIcon="far fa-reply-all" ttTooltipText="emailview_send_email_all" (ttClick)="replyAll.emit($event)"></tt-button>
                    </ng-container>
                </div>
            </div>

            <button
                *ngIf="recipientSummary"
                type="button"
                class="email-viewer__recipients"
                [class.email-viewer__recipients--expanded]="recipientsExpanded"
                [disabled]="!canExpandRecipients"
                [attr.aria-expanded]="canExpandRecipients ? recipientsExpanded : null"
                (click)="toggleRecipients()"
            >
                <span class="email-viewer__recipient-content">
                    <span class="email-viewer__recipient-row">
                        <strong><span ttTranslateWord="to"></span>:</strong>
                        <span class="email-viewer__recipient-summary">{{ recipientsExpanded ? toRecipients.join(", ") : recipientSummary }}</span>
                    </span>
                    <span *ngIf="recipientsExpanded && ccRecipients.length" class="email-viewer__recipient-row">
                        <strong><span ttTranslateWord="copy"></span>:</strong>
                        <span>{{ ccRecipients.join(", ") }}</span>
                    </span>
                </span>
                <span *ngIf="canExpandRecipients" class="far fa-chevron-down email-viewer__recipient-chevron" aria-hidden="true"></span>
            </button>

            <h2>{{ email.heading }}</h2>

            <section *ngIf="displayedAttachments.length" class="email-viewer__attachments" [attr.aria-label]="attachmentHeading">
                <strong>{{ attachmentHeading }}</strong>
                <div class="email-viewer__attachment-list">
                    <button
                        *ngFor="let attachment of displayedAttachments; trackBy: trackAttachment"
                        type="button"
                        class="email-viewer__attachment"
                        (click)="openAttachment($event, attachment)"
                    >
                        <span
                            class="email-viewer__attachment-icon"
                            [ngClass]="getAttachmentIcon(attachment)"
                            [style.color]="attachment.item_glyphicon_color || null"
                            aria-hidden="true"
                        ></span>
                        <span class="email-viewer__attachment-text">
                            <span>{{ getAttachmentName(attachment) }}</span>
                            <small *ngIf="getAttachmentDescription(attachment)">{{ getAttachmentDescription(attachment) }}</small>
                        </span>
                    </button>
                </div>
            </section>
        </header>

        <iframe
            *ngIf="body; else emptyBody"
            class="email-viewer__body"
            [attr.title]="email.heading || 'Email message'"
            [srcdoc]="body"
            sandbox="allow-popups allow-popups-to-escape-sandbox"
        ></iframe>
        <ng-template #emptyBody>
            <div class="email-viewer__status">No email content</div>
        </ng-template>

        <footer *ngIf="replyView === 'bottom'" class="email-viewer__reply-actions email-viewer__reply-actions--bottom">
            <tt-button ttText="emailview_send_email" ttIcon="far fa-reply" (ttClick)="reply.emit($event)"></tt-button>
            <tt-button ttText="emailview_send_email_all" ttIcon="far fa-reply-all" (ttClick)="replyAll.emit($event)"></tt-button>
        </footer>
    </ng-container>
</section>
